import { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '@/config/api';

const useGameReferences = (token) => {
  const [boards, setBoards] = useState([]);
  const [decks, setDecks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!token) {
      setBoards([]);
      setDecks([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const [boardsResponse, decksResponse] = await Promise.all([
        fetch(apiUrl('/api/boards'), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        fetch(apiUrl('/api/decks'), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);
      if (!boardsResponse.ok) {
        throw new Error('Не удалось загрузить список полей');
      }
      if (!decksResponse.ok) {
        throw new Error('Не удалось загрузить список колод');
      }
      const boardsData = await boardsResponse.json();
      const decksData = await decksResponse.json();
      setBoards(boardsData.boards || []);
      // Incomplete illustration decks are drafts, not playable game references.
      const playableDecks = (decksData.decks || []).filter((deck) => {
        if (deck.renderMode !== 'IMAGE') return true;
        const cards = Array.isArray(deck.cards) ? deck.cards : [];
        return cards.length === 72
          && new Set(cards.map((card) => card.cellNumber)).size === 72
          && cards.every((card) => card.cellNumber >= 1 && card.cellNumber <= 72 && Boolean(card.imageUrl));
      });
      setDecks(playableDecks);
    } catch (loadError) {
      setError(loadError.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    boards,
    decks,
    loading,
    error,
    reload: load,
  };
};

export default useGameReferences;
